import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAccount } from '../../Data/Voip';
import { useSession } from '../Session';
import twilioService from './TwilioService';
import { Roles } from '../../Data/Users';
import { useMobileContext } from '../Mobile/Provider';
import { createTwilioAdapter } from './adapters/TwilioAdapterFactory';
import { useOffline } from '../Offline';

const VoipContext = createContext();

export const useVoIP = () => {
    return useContext(VoipContext);
};

const VoIPProvider = ({ children }) => {
    const {isOnline} = useOffline();
    const {isReady, hasFeature, isAdmin, isRoleSufficient} = useSession();
    const mobile = useMobileContext();
    const {account, numbers} = useAccount(true, !isReady || !isOnline || !hasFeature('VOIP') || !isRoleSufficient(Roles.MANAGER));
    const [adapter, setAdapter] = useState(null);

    useEffect(() => {
        const shouldLoadTwilio = isOnline && isReady && isAdmin && numbers && numbers.length > 0;

        if (!shouldLoadTwilio) {
            return;
        }

        const twilioAdapter = createTwilioAdapter(mobile);
        setAdapter(twilioAdapter);
        twilioAdapter.register().catch(console.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAdmin, numbers, mobile?.isMobile]);

    const providerValues = {
        account,
        numbers,
        twilioService,
        adapter,
    };

    return (
        <VoipContext.Provider value={providerValues}>
            {children}
        </VoipContext.Provider>
    );
};

export default VoIPProvider;
